import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from './interface';
import { PSFilterConfig } from './filters/PSFilterConfig';
export const PartnerSkillingTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.PSTitle],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: PSFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: false,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: PSFilterConfig,
      Title: UATConstants.TenantTitles.RegionalSkilling,
      ADOTitle: UATConstants.TenantADOText.RegionalSkilling,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreatePSRequest,
          Key: UATConstants.CreateActionMenuKey.CreatePSRequest,
          NodeName: '',
        },
      ],
      BulkUpload: true,
      DownloadTemplate: true,
      DownloadTemplateConfig: {
        tenantToolName: 'regionalskilling',
        title: UATConstants.RSD,
        excelColumnSequence: {
          'Title': 1,
          'Assigned Team': 2,
          'Action Owner': 3,
          'Partner Type': 4,
          'Partner One ID': 5,
          'Partner Name': 6,
          'Partner Region': 7,
          'Partner Country': 8,
          'Partner Region1': 9,
          'Partner Country1': 10,
          'Skilling Plan Count': 11,
        },
        excludedColumns: ['Campaign', 'If others', 'Sub Campaign', 'Request Type'],
      },
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: false,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: true,
      BulkDelete: true,
      BulkEditConfig: [],
      CreateRAID: false,
    },
    ManageAction: {
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedto', formFieldLabel: UATConstants.PlaceholdersAndTitles.ActionOwner, apiFieldName: 'assignedto' },
        { formFieldName: 'rs_pdmname', formFieldLabel: UATConstants.PartnerSkillingTitles.PDMName, apiFieldName: 'rs_pdmname' },
      ],
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: true,
      isArtemisIntegrationEnabled: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '',//need to modify
      systemViewsFolderId: 'b3559237-bd7b-44c4-b7d9-b8cb6ef017e3',//need to modify
      sharedViewsFolderId: '1dbfbbc2-46f0-467d-8225-b650f49ff9f6',//need to modify
    },
  },
};
// Generated by GitHub Copilot | Updated on: 2026-06-15 | 1 line modified | Added Skilling Plan Count to download template excelColumnSequence
// Generated by GitHub Copilot | Updated on: 2026-10-21 | 13 lines modified | Excluded retired Regional Skilling import columns
